import Home from '@App/pages/Home/Home';
import NoMatch from '@App/pages/NoMatch/NoMatch';
import MapLayout from '@App/components/MapLayout/MapLayout';
import NavWrapper from '@App/components/NavWrapper/NavWrapper';

const routes = [
  {
    element: <NavWrapper />,
    children: [
      {
        element: <MapLayout />,
        path: '/',
        children: [
          {
            path: 'home',
            element: <Home />,
            handle: { name: 'Mission setup' },
          },
        ],
      },
      {
        path: '*',
        element: <NoMatch />,
      },
    ],
  },
];

export default routes;
